/* On hover-capable devices, hovering a colour sibling previews it in the card's main image. */
if (!customElements.get('product-card-siblings')) {
  class ProductCardSiblings extends HTMLElement {
    constructor() {
      super();
      // Bound once here: carousels and collection tabs move cards, re-running connectedCallback.
      this.addEventListener('mouseover', this.preview.bind(this));
      this.addEventListener('mouseleave', this.restore.bind(this));
    }
    connectedCallback() {
      const card = this.closest('product-card');
      this.image = card && window.matchMedia('(hover: hover)').matches ? card.querySelector('.product-primary-image') : null;
      // Kept from the first connect: a carousel moving the card re-runs this, possibly mid-preview.
      this.original_srcset ??= this.image ? this.image.getAttribute('srcset') : null;
    }
    preview(evt) {
      const sibling = evt.target.closest('.product-card-sibling');
      if (this.image && this.original_srcset && sibling) {
        this.image.setAttribute('srcset', sibling.dataset.srcset || this.original_srcset);
      }
    }
    restore() {
      if (this.image && this.original_srcset) {
        this.image.setAttribute('srcset', this.original_srcset);
      }
    }
  }
  customElements.define('product-card-siblings', ProductCardSiblings);

  // A page restored by the Back button keeps whichever preview was showing when a sibling was clicked.
  window.addEventListener('pageshow', (evt) => {
    if (evt.persisted) {
      document.querySelectorAll('product-card-siblings').forEach((siblings) => siblings.restore());
    }
  });
}
